export default {
  id: 113,
  title: 'Target #113 - Black Light',
  url: 'https://cssbattle.dev/play/113',
  colors: ['#5776F6', '#191919'],
  solution:
    '<p><style>body{background:#5776f6;margin:0}p{width:400;height:300;background:#191919;clip-path:polygon(0 125px,100% 100px,100% 200px,0 175px)}</style>',
}
